import { Component, computed, inject, Signal } from '@angular/core';
import { MediaBlockService } from '../../services/media-block-service';

import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-additional-data',
  imports: [TranslateModule, ],
  templateUrl: './additional-data.html',
  styleUrl: './additional-data.scss',
})
export class AdditionalData {
  private mediaBlockService: MediaBlockService = inject(MediaBlockService);
  cadence: Signal<boolean> = computed(() => this.mediaBlockService.gpsFileData()?.cadence ?? false);
  power: Signal<boolean> = computed(() => this.mediaBlockService.gpsFileData()?.power ?? false);
  heartRate: Signal<boolean> = computed(() => this.mediaBlockService.gpsFileData()?.heartRate ?? false);
}
